import { ArrowDownwardIcon, ArrowUpwardIcon } from "icons";
import { colors } from "theme/palette";

import IconButton from "components/IconButton";
import { TableCell } from "components/Table";

interface IMoveCell {
  onMove: ({ direction }: { direction: "up" | "down" }) => void;
}

const MoveCell = ({ onMove }: IMoveCell) => (
  <TableCell
    sx={{
      borderRight: `1px solid ${colors.blue40}`,
      borderBottom: `1px solid ${colors.blue40}`,
    }}
    data-testid="table-cell-delete-row"
  >
    <IconButton
      size="small"
      onClick={() => onMove({ direction: "up" })}
      title="Move row up"
      dataTestid="move-table-row-up-button"
    >
      <ArrowUpwardIcon sx={{ width: "20px", height: "20px" }} />
    </IconButton>
    <IconButton
      size="small"
      onClick={() => onMove({ direction: "down" })}
      title="Move row up"
      dataTestid="move-table-row-down-button"
    >
      <ArrowDownwardIcon sx={{ width: "20px", height: "20px" }} />
    </IconButton>
  </TableCell>
);

export default MoveCell;
